import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment'
import 'moment/locale/sv'

moment.locale('sv')
Vue.use(VueMoment, {
  moment
})
